var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"header"},[_c('div',{staticClass:"header-inner container"},[_c('div',{staticClass:"row align-items-end"},[_c('div',{staticClass:"headline-xlg col"},[_vm._v("My Profile")])])])])
}]

export { render, staticRenderFns }